import { render, staticRenderFns } from "./NPAssetPowerDown.vue?vue&type=template&id=50dd1ea4&scoped=true&"
import script from "./NPAssetPowerDown.vue?vue&type=script&lang=js&"
export * from "./NPAssetPowerDown.vue?vue&type=script&lang=js&"
import style0 from "./NPAssetPowerDown.vue?vue&type=style&index=0&id=50dd1ea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd1ea4",
  null
  
)

export default component.exports